module.exports = __webpack_public_path__ + "static/privacy-choice-f12cefb30f17be769e46a4abbb0a49fa.png";